import { render, staticRenderFns } from "./AmountField.vue?vue&type=template&id=cb5ecfe4&scoped=true&"
import script from "./AmountField.vue?vue&type=script&lang=ts&"
export * from "./AmountField.vue?vue&type=script&lang=ts&"
import style0 from "./AmountField.vue?vue&type=style&index=0&id=cb5ecfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5ecfe4",
  null
  
)

export default component.exports